import { Guard, GuardService } from 'commons/components/guard/guard.component';
import { useAuthContext } from './hooks/use-auth-context.hook';

interface RoleGuardProps extends React.PropsWithChildren {
    allowedRole: string;
    forbidden?: React.ReactNode;
}

const RoleGuard = ({ children, allowedRole, forbidden }: RoleGuardProps) => {
    const { userRole } = useAuthContext();

    const guardService: GuardService<string> = {
        checkPermissions: (role) => userRole === role,
    };

    return (
        <Guard guardService={guardService} requiredPermissions={allowedRole} forbidden={forbidden}>
            {children}
        </Guard>
    );
};

export default RoleGuard;
